<template>
  <span class="">
    <template v-if="tiempoTranscurrido.dias > 0">
      <span class="time_">{{ tiempoTranscurrido.dias }}</span>
      <span class="time_text">día(s)</span>
    </template>
    <template v-if="tiempoTranscurrido.horas > 0">
      <span class="time_">{{ tiempoTranscurrido.horas }}</span>
      <span class="time_text">h</span>
    </template>
    <template>
      <span class="time_">{{ tiempoTranscurrido.minutos }}</span>
      <span class="time_text">min</span>
    </template>
    <template>
      <span class="time_">{{ tiempoTranscurrido.segundos }}</span>
      <span class="time_text">seg</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'ElapsedTimer',
  props: ['fechaCreacion'],
  data() {
    return {
      tiempoTranscurrido: '',
    };
  },
  mounted() {
    this.calcularTiempoTranscurrido();
    this.iniciarContador();
  },
  methods: {
    calcularTiempoTranscurrido() {
      const fechaCreacion = this.$moment(
        this.fechaCreacion,
        this.$moment.ISO_8601
      );
      // console.log('fechaCreacion', fechaCreacion);
      const ahora = this.$moment();
      const duracion = this.$moment.duration(ahora.diff(fechaCreacion));
      const dias = Math.floor(duracion.asDays());
      const horas = duracion.hours();
      const minutos = duracion.minutes();
      const segundos = duracion.seconds();
      this.tiempoTranscurrido = {
        dias,
        horas: horas < 10 ? `0${horas}` : horas,
        minutos: minutos < 10 ? `0${minutos}` : minutos,
        segundos: segundos < 10 ? `0${segundos}` : segundos,
      };
      // this.tiempoTranscurrido = duracion.humanize();
    },
    iniciarContador() {
      setInterval(() => {
        this.calcularTiempoTranscurrido();
      }, 1000);
    },
  },
};
</script>
<style scoped>
.time_text {
  font-size: 11px;
  margin: 0 2px;
}
.time_ {
  font-weight: 500;
  font-size: 16px;
}
</style>
